const supportedChannels = new Set(['email', 'sms'])
const positiveListConditions = new Set(['true_to_any', 'true_to_all', 'any'])

const conditionValue = condition =>
  typeof condition.data === 'string'
    ? condition.data
    : condition.data?.condition

const conditionConstraints = condition => ({
  ...(condition.constraints || {}),
  ...(condition.data?.constraints || {}),
})

export const correlateListSubscriptionChannel = (filter) => {
  if (!filter?.conditions?.length) return filter
  if (filter.logic?.some(token => String(token).toLowerCase() === 'or')) {
    return filter
  }

  const channels = filter.conditions
    .filter(condition => condition.name === 'subscribedTo')
    .filter(condition => supportedChannels.has(conditionValue(condition)))
    .map(condition => conditionValue(condition))
  if (new Set(channels).size !== 1) return filter
  const channel = channels[0]

  let changed = false
  const conditions = filter.conditions.map((condition) => {
    if (
      condition.name !== 'listSubscriptions'
      || !positiveListConditions.has(conditionValue(condition))
    ) {
      return condition
    }

    const currentConstraints = conditionConstraints(condition)
    const currentConstraint = currentConstraints.messagingChannel
    const nestedConstraints
      = condition.data && typeof condition.data === 'object'
        ? condition.data.constraints
        : undefined
    if (
      currentConstraint?.condition
      && currentConstraint.condition !== 'all'
    ) {
      if (!nestedConstraints) return condition

      changed = true
      const data = { ...condition.data }
      delete data.constraints
      return {
        ...condition,
        data,
        constraints: currentConstraints,
      }
    }

    changed = true
    let data = condition.data
    if (nestedConstraints) {
      data = { ...condition.data }
      delete data.constraints
    }

    return {
      ...condition,
      data,
      constraints: {
        ...currentConstraints,
        messagingChannel: {
          condition: channel,
          values: [],
        },
      },
    }
  })

  return changed ? { ...filter, conditions } : filter
}
